import { SplitText } from "../vendor/SplitText.min";
export const archiveTraitement = {
  init: function () {  

    function setupSplitsIntro() {
        const targets = gsap.utils.toArray(".introduction-cat-traitement-text");
        targets.forEach((target) => {
          let SplitClient = new SplitText(target, { type: "chars",linesClass: "split-child" });
          let chars = SplitClient.chars; //an array of all the divs that wrap each character
          gsap.to(chars, {
         
           opacity:1,
              ease: "power4.inOut",
              //  stagger: 0.011,
              stagger:0.15,
              
              scrollTrigger: {
                trigger: target,
                // markers: true,
                start: 'top 80%',
                end: 'bottom +30%',
                scrub: 1,
             
            }
          });
        });
      }
      
      setupSplitsIntro();


  }
};